import api from "../index";

export const GetTransactionsApi = (userId, params) => api.get(`UserMaster/GetTransaction-ByUserId?${params}`);